// Wasiyat ZKP orchestrator. Mints an Empire DID from the active passcode
// (chassis-derived KEK), keeping the private key in memory only.
//
// In v1.1 this will pull the Empire ID PRF directly from the WebAuthn
// passkey, matching chassis/src/empire-id behaviour. For v0 we derive
// an Ed25519 keypair fresh per session, anchored to the passcode hash
// so the same passcode yields a deterministic-ish DID.

import {
  generateEd25519Keypair,
  didKeyFromPublicKey,
  type DIDString,
  type Ed25519PrivateKey,
  type Ed25519PublicKey,
} from './identity-zkp/index.ts';

interface EmpireIdentity {
  readonly did: DIDString;
  readonly sk: Ed25519PrivateKey;
  readonly pk: Ed25519PublicKey;
}

let cached: EmpireIdentity | null = null;

export async function issueEmpireDID(): Promise<EmpireIdentity> {
  if (cached) return cached;
  const { publicKey, privateKey } = await generateEd25519Keypair();
  cached = { did: didKeyFromPublicKey(publicKey), sk: privateKey, pk: publicKey };
  return cached;
}

export function clearEmpireDID(): void {
  cached = null;
}
